import {Component, OnInit, ViewChild} from '@angular/core';
import {PromotionsSModel} from '../../../../../components/parentchild/promotionsS/promotionsS.model';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService} from 'primeng/primeng';
import {LocalStorageService} from 'ng2-webstorage';
import {NgForm} from '@angular/forms';
import {ApprovalClassModel} from '../../../../../components/googleClassroom/googleClassroom.model';
import {AddStudentRcModel, rciModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';
import {Router} from '@angular/router';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';
import * as html2pdf from "html2pdf.js"



@Component({
  selector: 'app-student-profile',
  templateUrl: './modify-papers.component.html',
  styleUrls: ['./modify-papers.component.css']
})

export class ModifyPapersComponent implements OnInit {
  @ViewChild('form') form : NgForm;
  selectedFile: File;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel()
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearId: any = [];
  yearname: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none"
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress : any =[];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = []
  guru: any = [];
  payload: any = [];
  public isEditable : Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName :any;

  extractedContent: any;

  selectedLanguage: number;
  questionLanguage = [
    {name: 'English', id: 'English'},
    {name: 'Sinhala', id: 'Sinhala'},
    {name: 'Tamil', id: 'Tamil'}
  ];
  queryInput: any;


  subjectsList: any = [];
  selectedSubject: any;
  selectedYear: any;
  selectedSemester: any;
  selectedTest: any;
  selectedPaperType: any;

  public isSuccessful: number = 0;
  public successOrErrorMsg: string = "";


  public grade: any = [];
  public selectedgrade:  any;
  public selectedsection:  any;

  public CurrentChild: any;
  public schoolLogo1 :string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City : any;
  public Pincode : any;
  public PrimaryPhonenumber : any;
  public WebsiteLink : any;
  public Email : any;
  public Logo : any;
  public RegNo :any;
  public userId :string;
  public childMapId : any = [];
  public TeacherNames : any = [];
  public EncodedLogo : any;
  public ShowLevelData: any;
  public selectedlevel: any;

  isLoading: boolean = false;
  errorMessage: string = '';
  displayErrorDialog: boolean = false;



  public typedText: string = '';
  private fullText: string = 'This is the text that will be typed!, Accessing well-structured question papers is crucial for students to excel in their academic pursuits. With carefully curated question papers, students gain the confidence to tackle examinations effectively, fostering a deeper understanding of subjects and enhancing their overall academic performance.';
  private currentIndex: number = 0;



  constructor(private dataAnalyticsService: DataAnalyticsService, private router: Router, private noticeboardService: NoticeboardService, private appConstants: AppConstants, private localStorage: LocalStorageService, private messageService: MessageService) {

    // this.schoolName = this.localStorage.retrieve('schoolname');
    this.schoolLogo1 = this.localStorage.retrieve('Logo');
    this.imgUrl1 = this.appConstants.fileDownloadUrl;
    // this.attachment = this.imgUrl1 + this.Logo;
    this.userId = this.localStorage.retrieve('id');
  }

  ngOnInit() {
    this.typeText();
    this.getLevelsName();
    this.getYearData();
    //----------------------------------
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');
    this.selectedPaperType = 0;
  }

  onSubmitClick() {
    if (!this.selectedFile) {
      console.error('No file selected');
      this.showErrorDialog("Please select a file");
      return;
    }

    this.isLoading = true;

    const timeoutId = setTimeout(() => {
      this.isLoading = false;
      this.messageService.add({
        severity: "error",
        summary: "Timeout",
        detail: "Sorry, something went wrong while uploading the paper"
      });
      this.showErrorDialog("Something went wrong while uploading the paper");
    }, 60000);

    this.dataAnalyticsService.modifyGeneratedQuestions(this.selectedFile, this.queryInput, this.selectedLanguage).subscribe(
      response => {
        console.log(response);
        clearTimeout(timeoutId);
        this.isLoading = false;

        // 🔽 Trigger download
        this.downloadDocxFile(response.fileBase64, response.fileName);

      },
      error => {
        clearTimeout(timeoutId);
        this.isLoading = false;
        console.error('Upload failed:', error);
        this.messageService.add({
          severity: "error",
          summary: "Upload Failed",
          detail: "There was an error processing the file."
        });
        this.showErrorDialog("There was an error processing the file.");
      }
    );
  }


  downloadDocxFile(base64: string, fileName: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link); // for Firefox
    link.click();
    document.body.removeChild(link); // cleanup
    URL.revokeObjectURL(link.href);
  }





  showErrorDialog(message: string) {
    this.errorMessage = message;
    this.displayErrorDialog = true;
    this.isLoading = false;
    this.isSuccessful = 2;
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile);  // You can access the file here
    }
  }

  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedSection.SectionId).finally(() => { }).subscribe(
      response => {
        let res: any = response;
        console.log("getSubjects", res);
        this.subjectsList = res.subsemList[0];
        this.getSemesterData()
        try {
          this.selectedSubject = this.subjectsList[0];
        } catch (error) {

        }
      },
      error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
      });
  }


  onSelectedSubject(subject){
    console.log("onSelectedSubject", subject);
  }


  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);

      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, 'result');
    })
  }






  PrintPdf() {
    // this.schoolLogo1 = this.EncodedLogo;
    // console.log(this.schoolLogo1 )
    this.previwbtn = true;
    this.printbtn = false;
    const options = {
      filename: this.nameofstudent,
      margin: [15, 0, 15, 0],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      html2canvas: {
        dpi: 192,
        scale: 4,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('asdf')

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  edit(){
    this.isEditable= false;
  }

  discard(){
    this.getStudentRecord(this.studentId,this.testId,this.yearId);
    this.getAveragePerformances(this.sectionId,this.testId,this.studentId,this.yearId);
  }

  back(){
    this.previwbtn = true;
    this.printbtn = false;
  }

  preview() {
    // this.selectStyle = 'as';
    this.previwbtn = false;
    this.printbtn = true;
    this.getSchoolDetailsForRC(this.studentId);
  }

  // private getClassSection() {
  //   this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
  //     response => {
  //       this.studentData = response;
  //       let mappedData: any = response;
  //       mappedData.forEach(standard => {
  //         standard['Sections'].forEach(section => {
  //           section['StdId'] = standard['standardId'];
  //           section['StdName'] = standard['standardsName'];
  //           section['selected'] = false;
  //           // console.log(section)
  //         });
  //         // console.log(standard)
  //       });
  //       this.studentData = mappedData;
  //       console.log(this.studentData)
  //       // this.get_userdetailes();
  //     },
  //     error => {
  //     });
  // };


  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedGrade = mappedData[mappedData.length - 1];
          this.getSectionByGrade(this.selectedGrade);
          this.selectedSection = this.selectedGrade.Sections[0];
          this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /*else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }*/
      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
        this.selectedSubject = null;
      });
  };

  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (this.adminUserFlag) {
          this.mappedData = mappedData;
          // this.priorityFlag = true;
        }
        else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }
      },
      error => {
      });
  };

  private getAveragePerformances(SectionId,TestId,ChildId,YearId){
    this.dataAnalyticsService.GetAveragePerformances(SectionId,TestId,ChildId,YearId)._finally(() => {}).subscribe(
      response => {
        this.Averages = response;
        console.log(this.Averages);
      }
    )
  }

  private getStudentRecord(StudentId,TestId,yearId) {
    this.childMapId =[];
    this.loading= "block"
    this.dataAnalyticsService.getStudentRC(StudentId,TestId,yearId)._finally(() => {this.loading= "none"}).subscribe(
      response => {
        // console.log('studentRC', response)
        this.isEditable= true;
        this.studentRCData = response[0];
        this.studentRCData.studentRCInnerModels.sort((a, b) => ("" + a.Subject).localeCompare(b.Subject, undefined, { numeric: true }));
        console.log('studentRC', this.studentRCData)
        this.calculatePercentagesOnTheFly();
      }
    );
  }

  calculatePercentagesOnTheFly(){
    this.studentRCData.studentRCInnerModels.forEach(element => {
      let subsubjectPercentage = [];
      for(let i = 0; i < element.SubSubjectMaxMarks.length; i++) {
        if(isNaN(element.SubSubjectsMarks[i]) || element.SubSubjectsMarks[i] < 0 || element.SubSubjectsMarks[i] > element.SubSubjectMaxMarks[i]) {
          element.SubSubjectsMarks[i] = 0;
        }
        let percentage;
        if(element.SubSubjectAbsent[i] == 1){
          percentage = 0;
        }else{
          percentage = (element.SubSubjectsMarks[i] / element.SubSubjectMaxMarks[i]) * 100;
        }
        subsubjectPercentage.push(percentage.toFixed(2));
      }
      element.subsubjectPercentage = subsubjectPercentage;
      element.Percentage = this.calculateSubjectPercentage(element.SubSubjectsMarks, element.SubSubjectMaxMarks, element.SubSubjectWeight, element.SubSubjectAbsent);
      element.Marks = this.calculateSubjectPercentage(element.SubSubjectsMarks, element.SubSubjectMaxMarks, element.SubSubjectWeight, element.SubSubjectAbsent);
      element.MaxMarks = 100;
    });
    console.log("calculatePercentagesOnTheFly", this.studentRCData);
  }

  private calculateSubjectPercentage(subMarks, maxMarks, weight, absent) {
    let subPercentage = subMarks.map((marks, index) => {
      if(absent[index] == 1){
        return 0;
      }else{
        return (marks / maxMarks[index]) * 100;
      }
    });

    let totalWeight = weight.reduce((a, b) => a + b, 0);
    let subjectMarks = subPercentage.reduce((acc, curr, index) => {
      return acc + curr * weight[index];
    }, 0);

    return (subjectMarks / totalWeight).toFixed();
  }

  getSectionByGrade(grade) {
    //this.students = [];
    //this.NumberOfStudents = [];
    //this.SemesterData = [];
    //this.TestData = [];
    //this.studentRCData = [];
    //this.studentData.standardId = grade.standardId
    //this.standardId = grade.standardId
    //this.selectedSection = [];
    //this.nameofstudent = [];
    //this.nameofstd = grade.standardsName
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    this.sectionList.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection = this.sectionList[0];
      this.getSubjects();
    } catch (error) {

    }
  }


  getGclClassesListById(section) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.nameofstudent = [];
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    console.log('getGclClassesListById', section);
    this.getSubjects();
  }
  // (minutes >= 1 && minutes <= 15)

  getColor(Percentage) {
    switch (true) {
      case Percentage >= 0 && Percentage <= 49:
        return 'red';
      case Percentage >= 50 && Percentage <= 75:
        return 'orange';
      case Percentage >= 76 && Percentage <= 100:
        return ' #39FF14';
      // case Percentage >= 85 && Percentage <= 100:
      //   return 'skyblue';
    }
  }

  getRedColor(IsAbsent) {
    switch (true) {
      case IsAbsent == 1:
        return 'red';
    }
  }

  public postScore() {
    // this.percentage();
    this.valid();
    // this.isEditable = true;
    this.rcimodel.testid= this.testId
    this.rcimodel.childid = this.studentId;
    this.rcimodel.userid = this.userId;
    this.rcimodel.AcademicYearId = this.yearId
    this.rcimodel.OverallComments=this.studentRCData.OverallComments
    //this.rcimodel.OverallPosition=this.studentRCData.OverallPosition
    //this.rcimodel.studentsRCModels =this.studentRCData.studentRCInnerModels
    this.calculatePercentagesOnTheFly();
    var rc = [];
    this.studentRCData.studentRCInnerModels.forEach(element => {
      let subject : any = {};
      subject.ChildTestMappingId = element.ChildTestMappingId;
      subject.SubjectTestMappingId = element.SubjectTestMappingId;
      subject.Marks = Number(element.Marks);
      subject.Percentage = Number(element.Marks);
      subject.Comments = element.Comments;
      subject.SubjectSemesterPercentage = Number(element.Marks);
      subject.SubSubjectsIds = element.SubSubjectsIds;
      subject.SubSubjectsMarks = element.SubSubjectsMarks.map(val => Number(val));
      subject.SubAbsent = element.SubSubjectAbsent.map(val => val ? 1 : 0);
      rc.push(subject);
    });
    this.rcimodel.studentsRCModels = rc;
    console.log(this.rcimodel)
    this.dataAnalyticsService.postScore(this.rcimodel).finally(() => { }).subscribe(
      response => {
        console.log(response);
        this.isEditable = true;
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Score/Comments Added Successfully' });
        this.getStudentRecord(this.studentId,this.testId,this.yearId);
        this.getAveragePerformances(this.sectionId,this.testId,this.studentId,this.yearId);
      },
      error => {
        console.log(error);
        // this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Marks has to be less than or equal to max marks' });
      }
    );
  }

  private getStudentData(StandardId,SectionId,AcademicYear) {
    this.dataAnalyticsService.getStudents(StandardId,SectionId,AcademicYear)._finally(() => { }).subscribe(
      response => {
        this.students = response['studentsList'];

        console.log(this.students )
        this.NumberOfStudents = response['No_of_Students'];
        // console.log(this.NumberOfStudents )

      }
    )
  }

  getStudentListById(student) {
    this.studentRCData = [];
    this.SemesterData = [];
    this.TestData = [];
    this.nameofstudent = student.StudentName;
    this.studentId = student.StudentId;
    console.log(this.studentId)
    this.getSemesterData();
    // this.getStudentRecord(this.studentId);
  }

  getYearList(year) {
    console.log(year)
    //this.mappedData = [];
    //this.sectionList = [];
    //this.students = [];
    //this.NumberOfStudents = [];
    //this.studentRCData = [];
    //this.SemesterData = [];
    //this.TestData = [];
    //this.studentData = []
    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;
    //this.nameofstudent = [];
    //this.getClassSection()
    console.log(this.yearname)
    console.log(this.yearId)

  }

  private getSemesterData() {
    this.dataAnalyticsService.getSemester(this.yearId)._finally(() => { }).subscribe(
      response => {
        this.SemesterData = response['semestersList'];
        console.log("Semesters",this.SemesterData )
        // console.log("academicYearId", academicYearId )

        try {
          this.selectedSemester = this.SemesterData[0];
          this.getTestData(this.selectedSemester.SemesterId);
        } catch (error) {

        }
      }
    )
  }



  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        // console.log(this.YearData);
        this.yearId = this.YearData[0].YearId;
        console.log(this.yearId);
        try {
          this.selectedYear = this.YearData[0];
        } catch (error) {

        }

        // console.log(response )
      }
    )
  }

  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedlevel);

        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }

  getLevelsListById(){
    console.log("fffff", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }

////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////
  private GetGrade(){
    this.dataAnalyticsService.getGradeLevel(this.selectedlevel).finally(() => { }).subscribe(
      response => {
        this.grade = response;
        try {
          this.selectedgrade =  this.grade[0].standardId;

        } catch (error) {

        }
        console.log('grade',this.grade)
      },
      error => {
        this.grade = [];
        console.error(error);
        console.log('grade',this.grade)
      });
  };

  changegrade() {
    console.log(this.selectedgrade)

  };
  changesection(){
    console.log(this.selectedsection)
  }

////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////


  getSemesterListById(sem){
    console.log(sem)
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsem= sem.SemesterName;
    this.getTestData(sem.SemesterId);
  }

  private getTestData(SemesterId) {
    this.dataAnalyticsService.getTest(SemesterId)._finally(() => { }).subscribe(
      response => {
        this.TestData = response['testsList'];
        try {
          this.selectedTest = this.TestData[0];
        } catch (error) {

        }

        console.log(this.TestData )
      }
    )
  }

  getTestListById(test){
    console.log(test)
    this.studentRCData = [];
    this.testId = test.TestId;
    this.nameoftest = test.TestName;
    //this.getStudentRecord(this.studentId,this.testId,this.yearId);
    //this.getAveragePerformances(this.sectionId,this.testId,this.studentId,this.yearId);
    // this.getSchoolDetailsForRC(this.studentId);
    console.log('ids', this.testId,this.studentId)
  }

  private getSchoolDetailsForRC(studentId) {
    this.dataAnalyticsService.getSchoolDetailsForRC(studentId,this.childMapId)._finally(() => { }).subscribe(
      response => {
        this.SchoolDetailsaddress = response;
        console.log(this.SchoolDetailsaddress )
        this.schoolName = this.SchoolDetailsaddress.SchoolName;
        this.Address = this.SchoolDetailsaddress.Address;
        this.City = this.SchoolDetailsaddress.City;
        this.Pincode = this.SchoolDetailsaddress.Pincode;
        this.PrimaryPhonenumber = this.SchoolDetailsaddress.PrimaryPhonenumber;
        this.WebsiteLink = this.SchoolDetailsaddress.WebsiteLink;
        this.Email = this.SchoolDetailsaddress.Email;
        this.Logo = this.SchoolDetailsaddress.Logo;
        this.RegNo = this.SchoolDetailsaddress.RegNo;
        // console.log(this.schoolName )
        // this.attachment = this.imgUrl1 + this.Logo;
        this.attachment = this.imgUrl1 + this.schoolLogo1;
        // this.EncodedLogo = 'data:image/jpg;base64,' + btoa(this.attachment)
        // console.log(this.attachment )
        this.SchoolDetailsaddress.Teachers.forEach(element => {
          // element["TeacherName"] =element.TeacherName;
          this.TeacherNames= element.TeacherName
          console.log(this.TeacherNames)
          // this.TeacherNames = this.TeacherNames.filter(a=> a.TeacherName == element.TeacherName)
        });
      }
    )
  }

  // private percentage(){
  //   this.studentRCData.studentRCInnerModels.forEach(element => {
  //   element["Percentage"] = ((element.Marks / element.MaxMarks) * 100).toFixed(2);
  //     console.log(element)
  //   });
  //   console.log(this.studentRCData)
  // }

  private valid(){
    this.studentRCData.studentRCInnerModels.forEach(element => {
      if( element.Marks > element.MaxMarks){
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Marks has to be less than or equal to max marks' });
      }
      else{
        // element["Percentage"] = ((element.Marks / element.MaxMarks) * 100).toFixed(2);
        element["Percentage"] = (element.Marks!=null && element.MaxMarks!=null)?((element.Marks / element.MaxMarks) * 100).toFixed(2):null;
        element["SubjectSemesterPercentage"] = null;
      }

    });
    // this.RemovePercentage()
  }



  onCheckboxChange(event, index)
  {
    if (event.target.checked) {
      //this.studentRCData.studentRCInnerModels[index].Marks = 0
      //this.studentRCData.studentRCInnerModels[index].Comments = "ABSENT"
      //this.studentRCData.studentRCInnerModels[index].IsAbsent = true
    }else{
      //this.studentRCData.studentRCInnerModels[index].IsAbsent = false
      //this.studentRCData.studentRCInnerModels[index].Comments = null
    }
    this.calculatePercentagesOnTheFly();
  }


  private typeText() {
    if (this.currentIndex < this.fullText.length) {
      this.typedText += this.fullText[this.currentIndex++];
      setTimeout(() => this.typeText(), 100); // Adjust timing for typing speed
    }
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/modify-papers/modify-papers.component.ts